import React from 'react';
import { motion } from 'framer-motion';
import { trackAddToCart } from '../../utils/metaPixel';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'accent';
  size?: 'sm' | 'md' | 'lg';
  children: React.ReactNode;
}
export function Button({
  variant = 'primary',
  size = 'md',
  children,
  className = '',
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center font-bold rounded-full transition-all duration-300 shadow-md hover:shadow-lg z-10 relative';
  const variants = {
    primary: 'bg-partyPink-hot text-white hover:bg-pink-600 hover:shadow-glow',
    secondary: 'bg-white text-partyPink-hot border-2 border-partyPink-hot hover:bg-partyPink-light',
    accent: 'bg-mint-dark text-white hover:bg-teal-500'
  };
  const sizes = {
    sm: 'px-6 py-2 text-sm',
    md: 'px-8 py-3 text-base',
    lg: 'px-12 py-5 text-xl md:text-2xl uppercase tracking-wider'
  };
  return <motion.a href="https://librodigitall.com/cart/56993529299275:1" target="_blank" rel="noopener noreferrer" onClick={() => trackAddToCart()} whileHover={{
    scale: 1.05
  }} whileTap={{
    scale: 0.95
  }} className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${className} cursor-pointer no-underline`} data-id="element-210">
      {children}
    </motion.a>;
}